
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../base/Button';
import LanguageSelector from '../base/LanguageSelector';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useTranslation();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-[#F5F1E6]">
      <div className="w-full px-6 lg:px-12 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/6937990301fbd1dfa12b06d3bf61a237.png" 
              alt="LunaKey" 
              className="h-3.5 sm:h-4 lg:h-4 w-auto object-contain"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('story')}
              className="text-xs text-[#2A2A2A] hover:text-[#A6A6A6] transition-colors cursor-pointer"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              {t('brand_story')}
            </button>
            <button 
              onClick={() => scrollToSection('philosophy')}
              className="text-xs text-[#2A2A2A] hover:text-[#A6A6A6] transition-colors cursor-pointer"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              {t('our_philosophy')}
            </button>
            <button 
              onClick={() => scrollToSection('products')}
              className="text-xs text-[#2A2A2A] hover:text-[#A6A6A6] transition-colors cursor-pointer"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              {t('product_series')}
            </button>
            <button 
              onClick={() => scrollToSection('sourcing')}
              className="text-xs text-[#2A2A2A] hover:text-[#A6A6A6] transition-colors cursor-pointer"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              {t('global_sourcing')}
            </button>
            <LanguageSelector />
            <Button size="sm" onClick={() => scrollToSection('newsletter')} className="text-xs">
              {t('start_journey')}
            </Button>
          </nav>

          {/* Mobile Navigation Controls */}
          <div className="lg:hidden flex items-center space-x-3">
            <LanguageSelector isMobile />
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="w-3 h-3 flex items-center justify-center cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xs text-[#2A2A2A]`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden mt-4 pb-4 border-t border-[#F5F1E6] pt-4">
            <div className="flex flex-col space-y-3">
              <button 
                onClick={() => scrollToSection('story')}
                className="text-left text-xs text-[#2A2A2A] hover:text-[#A6A6A6] transition-colors cursor-pointer py-2"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                {t('brand_story')}
              </button>
              <button 
                onClick={() => scrollToSection('philosophy')}
                className="text-left text-xs text-[#2A2A2A] hover=text-[#A6A6A6] transition-colors cursor-pointer py-2"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                {t('our_philosophy')}
              </button>
              <button 
                onClick={() => scrollToSection('products')}
                className="text-left text-xs text-[#2A2A2A] hover:text-[#A6A6A6] transition-colors cursor-pointer py-2"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                {t('product_series')}
              </button>
              <button 
                onClick={() => scrollToSection('sourcing')}
                className="text-left text-xs text-[#2A2A2A] hover:text-[#A6A6A6] transition-colors cursor-pointer py-2"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                {t('global_sourcing')}
              </button>
              <div className="pt-2">
                <Button size="sm" onClick={() => scrollToSection('newsletter')} className="text-xs">
                  {t('start_journey')}
                </Button>
              </div>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
